import { getSavedReportURLByReportType } from '../../../../components/insights/saved_report_util';
export const openReport = (report, history) => {
    const path = getSavedReportURLByReportType(report.type, report.id);
    history.push(path);
};
